const A = 1e3, _ = 2147483647;
export {
  A as DEFAULT_INTERVAL_MS,
  _ as MAX_INTERVAL_MS
};
